export default __webpack_public_path__ + "static/media/3.8f99fcbf.jpg";